import { render, staticRenderFns } from "./numeracion.vue?vue&type=template&id=15f066ce"
import script from "./numeracion.vue?vue&type=script&lang=js"
export * from "./numeracion.vue?vue&type=script&lang=js"
import style0 from "./numeracion.vue?vue&type=style&index=0&id=15f066ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports